import { render, staticRenderFns } from "./SignPanel.vue?vue&type=template&id=2fa471c6&scoped=true&"
import script from "./SignPanel.vue?vue&type=script&lang=js&"
export * from "./SignPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa471c6",
  null
  
)

export default component.exports